var LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
var LOCAL_STORAGE_DELIMITER = ',';
var BUTTON_ACTIVE_CLASS = 'active';

var selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
  count: '[data-wishlist-count]',
};

document.addEventListener('DOMContentLoaded', function () {
  var buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);

  setupWishlistClickHandler();
  updateWishlistCount();

  var grid = document.querySelector(selectors.grid) || false;
  if (grid) {
    setupGrid(grid);
  }
});

var setupGrid = function (grid) {
  var wishlist = getWishlist();
  var wishlistExistEl = document.querySelector('.wishlist-page');

  if (wishlistExistEl && wishlist.length > 0) {
    wishlistExistEl.classList.add('wishlist_exists');
  }

  var requests = wishlist.map(function (handle) {
    var productTileTemplateUrl = '/products/' + handle + '?view=card';

    return fetch(productTileTemplateUrl).then(function (res) {
      if (!res.ok) return '';
      return res.text();
    }).catch(function () {
      return '';
    });
  });

  Promise.all(requests).then(function (responses) {
    var wishlistProductCards = responses.join('');
    grid.innerHTML = wishlistProductCards;

    var buttons = grid.querySelectorAll(selectors.button) || [];
    if (buttons.length) setupButtons(buttons);
  });
};

var setupButtons = function (buttons) {
  [].forEach.call(buttons, function (button) {
    var productHandle = button.dataset.productHandle || false;

    if (!productHandle) {
      return console.error('[Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
    }

    if (wishlistContains(productHandle)) {
      button.classList.add(BUTTON_ACTIVE_CLASS);
    } else {
      button.classList.remove(BUTTON_ACTIVE_CLASS);
    }
  });
};

var setupWishlistClickHandler = function () {
  document.addEventListener('click', function (event) {
    var target = event.target;

    if (!target.closest && target.parentElement) {
      target = target.parentElement;
    }

    var button = target.closest ? target.closest(selectors.button) : false;
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    var productHandle = button.dataset.productHandle || false;

    if (!productHandle) {
      return console.error('[Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
    }

    updateWishlist(productHandle);

    var isActive = wishlistContains(productHandle);
    updateButtonsForHandle(productHandle, isActive);
    updateWishlistCount();
    updateWishlistGridAfterClick(button, isActive);

    setWishlistButtonLoadingState(button);
  }, true);
};

var getWishlist = function () {
  var wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER).filter(Boolean);
  return [];
};

var setWishlist = function (array) {
  var cleanWishlist = array.filter(Boolean);
  var wishlist = cleanWishlist.join(LOCAL_STORAGE_DELIMITER);

  if (cleanWishlist.length) {
    localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  } else {
    localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
  }

  return wishlist;
};

var updateWishlist = function (handle) {
  var wishlist = getWishlist();
  var indexInWishlist = wishlist.indexOf(handle);

  if (indexInWishlist === -1) {
    wishlist.push(handle);
  } else {
    wishlist.splice(indexInWishlist, 1);
  }

  return setWishlist(wishlist);
};

var updateButtonsForHandle = function (handle, isActive) {
  var buttons = document.querySelectorAll(selectors.button + '[data-product-handle="' + handle + '"]') || [];

  [].forEach.call(buttons, function (button) {
    button.classList.toggle(BUTTON_ACTIVE_CLASS, isActive);
  });
};

var updateWishlistCount = function () {
  var count = getWishlist().length;
  var countEls = document.querySelectorAll(selectors.count) || [];

  [].forEach.call(countEls, function (countEl) {
    countEl.textContent = count;
    countEl.style.display = count ? '' : 'none';
  });
};

var updateWishlistGridAfterClick = function (button, isActive) {
  var grid = button.closest ? button.closest(selectors.grid) : false;
  if (!grid || isActive) return;

  var item = button.closest('.wishlist-product-item');
  if (item) item.parentNode.removeChild(item);

  var wishlistPage = document.querySelector('.wishlist-page');
  if (wishlistPage && !grid.querySelector('.wishlist-product-item')) {
    wishlistPage.classList.remove('wishlist_exists');
  }
};

var wishlistContains = function (handle) {
  var wishlist = getWishlist();
  return wishlist.indexOf(handle) !== -1;
};

var resetWishlist = function () {
  return setWishlist([]);
};

var setWishlistButtonLoadingState = function (button) {
  button.classList.add('loading-wishlist', 'adding-wishlist');

  setTimeout(function () {
    button.classList.remove('loading-wishlist');
  }, 1000);

  setTimeout(function () {
    button.classList.remove('adding-wishlist');
  }, 2000);
};
